export default __webpack_public_path__ + "189d2a20e5c03bb257845c296fff6c9a.svg";